var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTrash = function SvgTrash(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__a",
    d: "M0 0h25.281v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "trash_svg__b",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.573 25.947a2.708 2.708 0 0 1-2.696 2.705H6.404a2.707 2.707 0 0 1-2.696-2.705V4.719h17.865v21.228zM8.764 3.367c0-1.191 1.053-2.019 2.244-2.019h3.686c1.19 0 2.16.828 2.16 2.018v.005h-8.09v-.005zm15.843.004h-2.265c-.031-.005-.062-.01-.095-.01-.032 0-.063.005-.095.01h-3.95v-.005C18.202 1.432 16.63 0 14.694 0h-3.686C9.073 0 7.416 1.432 7.416 3.366v.005H3.128a.576.576 0 0 0-.094-.01.588.588 0 0 0-.095.01H.674a.674.674 0 0 0 0 1.348H2.36v21.228A4.056 4.056 0 0 0 6.404 30h12.473a4.056 4.056 0 0 0 4.044-4.053V4.719h1.686a.674.674 0 0 0 0-1.348z",
    mask: "url(#trash_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.09 24.944a.674.674 0 0 0 .674-.674V9.1a.674.674 0 0 0-1.348 0v15.17c0 .372.302.674.674.674m4.719 0a.674.674 0 0 0 .674-.674V9.1a.674.674 0 0 0-1.348 0v15.17c0 .372.302.674.674.674m4.719 0a.674.674 0 0 0 .674-.674V9.1a.674.674 0 0 0-1.348 0v15.17c0 .372.302.674.674.674"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;